import { observable, computed, action, makeObservable } from 'mobx'
import Document from 'documents/Document'
import ModalViewModel from 'infra/ModalViewModel'
import Job from 'jobs/Job'
import { DocumentActionsAdapter } from 'documents/DocumentActionsAdapter'
import { AlertFactory, AlertState } from 'alerts/Alert'

export class DocumentManualVerificationViewModel extends ModalViewModel {
  @observable document: Document | null = null
  @observable job: Job | null = null

  constructor(
    private documentActionsAdapter: DocumentActionsAdapter,
    private newAlert: AlertFactory,
  ) {
    super()
    makeObservable(this)
  }

  @computed
  get fileName() {
    return this.document?.latestVersion?.files[0].fileName
  }

  @computed
  get clientName() {
    return this.job?.championClient?.member.displayName
  }

  @computed
  get documentContentClientName() {
    const firstName = this.document?.latestVersion?.fields.find(
      (field) => field.id === 'first_name',
    )
    const lastName = this.document?.latestVersion?.fields.find(
      (field) => field.id === 'last_name',
    )

    const name = this.document?.latestVersion?.fields.find(
      (field) => field.id === 'name',
    )

    return name?.extractedValue
      ? `${name?.extractedValue}`
      : `${firstName?.extractedValue} ${lastName?.extractedValue}`
  }

  @action.bound
  open(document: Document, job: Job) {
    this.document = document
    this.job = job
    this.show()
  }

  @action.bound
  async confirmDocument() {
    if (!this.document?.latestVersion?.files[0]) {
      return
    }
    try {
      await this.documentActionsAdapter.confirmDocument(
        this.document.id,
        this.document.latestVersion.id,
        this.document.latestVersion.files[0].id,
      )
      this.close()
    } catch (error) {
      this.newAlert().fromError(error).show()
      this.close()
      console.error(error)
    }
  }

  @action.bound
  async deleteDocument() {
    if (!this.document) {
      return
    }

    try {
      const docTitle = this.document.title
      await this.documentActionsAdapter.archiveDocument(this.document)

      this.newAlert()
        .withState(AlertState.Success)
        .saying(`Success!  Document ${docTitle} has been removed!`)
        .autoDismiss()
        .show()

      this.close()
    } catch (error) {
      this.newAlert().fromError(error).show()
      this.close()
      console.error(error)
    }
  }
}
